import React from "react";
import {connect} from "react-redux";
import {Row, Col} from "react-bootstrap";
import SummaryPickupSite from "../../components/summary/SummaryPickupSite";
import SummaryItems from "../../components/summary/SummaryItems.js";
import SummaryPaymentPlan from "../../components/summary/SummaryPaymentPlan.js";
import SummaryTotals from "../../components/summary/SummaryTotals.js";
import SummaryDistributionDate from "../../components/summary/SummaryDistributionDate.js";
import {JoinSteps} from "../../common/constants.js";
import {joinChangeItemQuantity} from "../../actions/join/joinActions.js";
import {setPickupSite, setWaitListPickupSite} from "../../actions/common/subscriptionSummaryActions";
import {calcTotals, getJoinSelectedItems, getNextDeliveryDate, getAllItemsRemainingDeliveryDates} from "../../common/basket.js";
import * as GA from "../../actions/common/gaActions.js";
import styles from "../../css/summary/summary.less";
import {translate} from '../../i18n/translate.js';

class JoinSummary extends React.Component {
    render() {
        const selectedItems = this.props.selectedItems.items.concat(this.props.selectedItems.waitlistItems);
        return (
            <div className="summary-container">
                <div className="secured-and-summary-wrapper">
                    <div className="secured-wrapper">{translate("Secured Payment & Privacy Protection")}</div>
                    <div className="summary-title">{translate("Summary")}</div>
                </div>
                <div className="summary-row" id="joinSummaryContainer">
                    <div className="scroll">
                        {this.props.pickupSite?
                            <SummaryDistributionDate nextDeliveryDate = {this.props.nextDeliveryDate}
                                                     deliveryDateLabel = {translate("First Distribution")}/>
                            : undefined
                        }
                        {!this.props.isWaitListOnly?
                            <SummaryPickupSite isFirstDistribution={true}
                                               schedules={this.props.schedules}
                                               allowRemove={this.props.step === JoinSteps.PICKUP_SITES}
                                               nextDeliveryDates={this.props.nextDeliveryDates}
                                               pickupSiteLabel={this.props.pickupSiteLabel}
                                               pickupSite={this.props.pickupSite}
                                               waitListSite={this.props.waitListSite}
                                               onRemovePickupSite={this.props.removePickupSite}/>
                            :undefined
                        }
                        {this.props.isAddSubscription && this.props.summaryItems && this.props.summaryItems.length > 0 && this.props.pickupSite?
                            <SummaryItems staticData={this.props.staticData}
                                          readOnly={true}
                                          items={this.props.summaryItems}
                                          title={translate("Existing")}
                                          includeTax={true}
                                          isFarmSeasonal={this.props.isFarmSeasonal}
                                          schedules={this.props.schedules}
                                          pickupSite={this.props.pickupSite}/>
                            : undefined
                        }
                        {selectedItems && selectedItems.length > 0 ?
                            <SummaryItems staticData={this.props.staticData}
                                          readOnly={this.props.step !== JoinSteps.SHARES && this.props.step !== JoinSteps.OPTIONS}
                                          allowChangeShares={this.props.step === JoinSteps.SHARES}
                                          allowChangeOptions={this.props.step === JoinSteps.SHARES || this.props.step === JoinSteps.OPTIONS}
                                          items={selectedItems}
                                          title={translate(this.props.isAddSubscription ? "Additional" : "Items")}
                                          isFarmSeasonal={this.props.isFarmSeasonal}
                                          schedules={this.props.schedules}
                                          pickupSite={this.props.pickupSite}
                                          onRemoveItem={this.props.removeItem}/>
                            : undefined
                        }
                        {this.props.paymentPlan ?
                            <SummaryPaymentPlan paymentPlan={this.props.paymentPlan}/>
                            : undefined
                        }
                        {this.props.totals ?
                            <SummaryTotals totals={this.props.totals}/>
                            : undefined
                        }
                    </div>
                </div>
            </div>);
    }
}

const mapStateToProps =  (state) =>  {
    const signupData = state.signupData||{};
    const summary = state.summary||{};
    const sharesData = signupData.sharesData || {};
    const selectedItems = getJoinSelectedItems(sharesData.shares, sharesData.options);
    const selectedData = (signupData.selectedData || {});
    const schedules = signupData.schedules || {};
    const nextDeliveryDates = (signupData.pickupSitesData || {}).nextDeliveryDates;
    const exceptionalPickupSites = (signupData.pickupSitesData || {}).exceptionalPickupSites;
    const isWaitListOnly =  (signupData.data || {}).isWaitListOnly;
    const summaryItems = summary.shareItems ? summary.shareItems.concat(summary.waitListItems) : [];

    let nextDeliveryDate;
    const pickupSite = summary.pickupSite;
    let totals;
    if (pickupSite && nextDeliveryDates) {
        
        nextDeliveryDate = getNextDeliveryDate(summary.pickupSite, selectedItems.items.concat(summaryItems), schedules, nextDeliveryDates);
        if(exceptionalPickupSites && exceptionalPickupSites.hasOwnProperty(summary.pickupSite.key)) {
            nextDeliveryDate = exceptionalPickupSites[summary.pickupSite.key];
        }
        //Run this calc only if a payment plan is selected
        if (selectedData.selectedPaymentPlan) {
            const itemsRemainingDates = getAllItemsRemainingDeliveryDates(selectedItems.items, signupData.sharesData.remainingScheduleDates);

            totals = calcTotals(state.signupData.data.isFarmSeasonal, summary.pickupSite, selectedItems.items, selectedData.selectedPaymentPlan,
                selectedData.coupon, itemsRemainingDates, signupData.sharesData.remainingScheduleDates,
                nextDeliveryDate, signupData.isAddSubscription, summary.discount, state.staticData, selectedData.selectedMethod).totals;
        }
    }

    return {
        signupData: signupData,
        staticData: state.staticData || {},
        pickupSiteLabel: state.staticData.pickupSiteLabel,
        nextDeliveryDates: nextDeliveryDates,
        selectedItems: selectedItems,
        summaryItems: summaryItems,
        schedules: schedules,
        isWaitListOnly: isWaitListOnly,
        waitListSite: summary.waitListSite,
        step: signupData.step,
        isFarmSeasonal: state.staticData.isFarmSeasonal,
        nextDeliveryDate: nextDeliveryDate,
        pickupSite: summary.pickupSite,
        paymentPlan: selectedData.selectedPaymentPlan,
        totals: totals
    };
};
const mapDispatchToProps =  (dispatch) => {
    return {
        removePickupSite: (isWaitList) => {
            if(!isWaitList) {
                dispatch(setPickupSite(null));
            } else {
                dispatch(setWaitListPickupSite(null));
            }
        },
        removeItem: (key, newQuantity) => {
            dispatch(joinChangeItemQuantity(key, newQuantity));
            // dispatch(GA.trackGAEvent(GA.GA_CATEGORIES.JOIN, GA.GA_ACTIONS.ITEM_REMOVED, GA.GA_LABELS.CART));
        }
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(JoinSummary);




// WEBPACK FOOTER //
// ./src/containers/join/JoinSummary.js